/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Limit_2_ValueInputs */

const en_svc_rag_limit_2_value = /** @type {(inputs: Svc_Rag_Limit_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People only get answers from material they are allowed to see.`)
};

const lv_svc_rag_limit_2_value = /** @type {(inputs: Svc_Rag_Limit_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cilvēki saņem atbildes tikai no materiāliem, ko viņiem atļauts redzēt.`)
};

/**
* | output |
* | --- |
* | "People only get answers from material they are allowed to see." |
*
* @param {Svc_Rag_Limit_2_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_limit_2_value = /** @type {((inputs?: Svc_Rag_Limit_2_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Limit_2_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_limit_2_value(inputs)
	return en_svc_rag_limit_2_value(inputs)
});